import { useSelector } from 'react-redux';
import { selectors } from 'reduxConfig';

export const useZipSearch = () => {
  const { lat, lon } = useSelector(selectors.zipSearch.selectSearchCoords);
  const searchRadius = useSelector(selectors.zipSearch.selectSearchRadius);
  return { lat, lon, searchRadius };
};
